// @ts-nocheck
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Icon } from 'antd';
import BigNumber from 'bignumber.js';
import NumberFormat from 'react-number-format';
import { TokenId } from 'types';
import { getToken } from 'utilities';
import { AuthContext } from 'context/AuthContext';
import WithdrawHistoryModal from './WithdrawHistoryModal';
import { CardItemWrapper } from '../styles';

const WithdrawCardWrapper = styled.div`
  .card-item {
    padding: 0;

    &.request-withdraw {
      border: unset;
    }
  }

  .request-withdraw {
    .left {
      position: relative;
      border-bottom: 1px solid #262b48;
      padding: 16px;
    }
    .right {
      position: relative;
      padding: 16px;
    }
    .column {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 165px;
    }
  }

  .lock-period {
    font-size: 12px;
    line-height: 16px;
  }

  @media only screen and (min-width: 992px) {
    .request-withdraw {
      .left {
        border-right: 1px solid #262b48;
        border-bottom: none;
      }
    }
  }
`;

function formatTimeToLockPeriodString(seconds: $TSFixMe) {
  let remaining = 0;
  const weeks = Math.floor(seconds / (7 * 86400));
  remaining = seconds - (weeks * 7 * 86400);
  const days = Math.floor(remaining / 86400);
  remaining -=  days * 86400;
  const hours = Math.floor(remaining / 3600);
  remaining -= hours * 3600;
  const minutes = Math.floor(remaining / 60);
  remaining -= minutes * 60;
  const second = remaining;

  return `${weeks ? `${weeks} weeks ` : ''}${days ? `${days} days ` : ''}${hours ? `${hours} hours ` : ''}${
    minutes ? `${minutes} minutes ` : ''
  }${second ? `${second} seconds` : ''}`;
}


interface WithdrawCardProps {
  poolId: BigNumber;
  brainVaultContract: any;
  stakedToken: TokenId;
  rewardTokenAddress: string | undefined;
  lockPeriodSecond: BigNumber;
  withdrawableAmount: BigNumber;
  pendingWithdrawals: unknown[];
  userEligibleStakedAmount: BigNumber;
}

function WithdrawCard({
  poolId,
  brainVaultContract,
  stakedToken,
  rewardTokenAddress,
  lockPeriodSecond,
  withdrawableAmount,
  pendingWithdrawals,
  userEligibleStakedAmount,
}: WithdrawCardProps) {
  const stakedTokenDecimal = new BigNumber(10).pow(getToken(stakedToken).decimals);
  const stakedTokenSymbol = getToken(stakedToken).symbol;
  const { account } = useContext(AuthContext);
  // const brainVaultContract = useBrainVaultContract();

  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState(new BigNumber(0));

  const [requestWithdrawLoading, setRequestWithdrawLoading] = useState(false);
  const [executeWithdrawLoading, setExecuteWithdrawLoading] = useState(false);

  return (
    <WithdrawCardWrapper>
      <CardItemWrapper>
        {/* withdraw area */}
        <div className="card-item request-withdraw">
          <Row type="flex">
            {/* Unlock Section */}
            <Col xs={{ span: 24 }} lg={{ span: 9 }} className="left column">
              <div className="card-content">
                <h3 style={{ textAlign: 'center', borderBottom: '1px solid #262b48;' }}>
                  {stakedToken === "brn" ? "Unlocked" : "Unlocked LP"}
                </h3>
                <div className="card-title">Unlocked amount</div>
                <div className="center-amount">
                  {withdrawableAmount.div(stakedTokenDecimal).toFixed(4)} {stakedTokenSymbol}
                </div>
              </div>
              <button
                type="button"
                className="button execute-withdraw-button"
                disabled={!withdrawableAmount.gt(0) || !account || executeWithdrawLoading}
                onClick={async () => {
                  setExecuteWithdrawLoading(true);
                  try {
                    await brainVaultContract.methods
                      .redeem(withdrawableAmount.toFixed())
                      .send({ from: account?.address });
                  } catch (e) {
                    console.log('>> execute withdraw error:', e);
                  }
                  setExecuteWithdrawLoading(false);
                }}
              >
                {executeWithdrawLoading && <Icon type="loading" />} Withdraw
              </button>
            </Col>

            {/* Withdraw Section */}
            <Col xs={{ span: 24 }} lg={{ span: 15 }} className="right column">
              <div className="card-content">
                <h3 style={{ textAlign: 'center', borderBottom: '1px solid #262b48;' }}>
                  Withdraw
                </h3>
                <div className="card-title">
                  <span>
                    Token Locked: {userEligibleStakedAmount.div(stakedTokenDecimal).toFixed(4)}
                  </span>
                  <Icon
                    type="history"
                    className="icon"
                    onClick={() => setHistoryModalVisible(!historyModalVisible)}
                  />
                </div>
                <div className="card-body">
                  <div className="input-wrapper">
                    <NumberFormat
                      autoFocus
                      value={withdrawAmount.isZero() ? '0' : withdrawAmount.toString(10)}
                      onValueChange={values => {
                        const value = new BigNumber(values.value || 0);
                        const maxValue = userEligibleStakedAmount.div(stakedTokenDecimal).dp(4, 1);
                        setWithdrawAmount(value.gt(maxValue) ? maxValue : value);
                      }}
                      thousandSeparator
                      allowNegative={false}
                      placeholder="0"
                    />
                    <span
                      className="pointer max"
                      onClick={() => {
                        setWithdrawAmount(userEligibleStakedAmount.div(stakedTokenDecimal));
                      }}
                    >
                      MAX
                    </span>
                  </div>
                  <div className="lock-period">
                    Locking period: {lockPeriodSecond.toString() === "10" ? "5 minutes" : `${formatTimeToLockPeriodString(lockPeriodSecond)}`}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="button claim-button"
                disabled={
                  !userEligibleStakedAmount.gt(0) ||
                  !withdrawAmount.gt(0) ||
                  !account ||
                  requestWithdrawLoading
                }
                onClick={async () => {
                  setRequestWithdrawLoading(true);
                  try {
                    await brainVaultContract.methods
                      .redeemEarly(withdrawAmount.multipliedBy(stakedTokenDecimal).toString(10))
                      .send({
                        from: account?.address,
                      });
                  } catch (e) {
                    console.log('>> request withdraw error: ', e);
                  }
                  setRequestWithdrawLoading(false);
                }}
              >
                {requestWithdrawLoading && <Icon type="loading" />} Withdraw Early
              </button>
              <div className="lock-period">
                {'40' /* TODO: Replace with fee */}% will be deducted on early withdrawls
              </div>
            </Col>
          </Row>
        </div>

        <WithdrawHistoryModal
          visible={historyModalVisible}
          onCancel={() => setHistoryModalVisible(false)}
          pendingWithdrawals={pendingWithdrawals}
          withdrawableAmount={withdrawableAmount}
          stakedToken={stakedToken}
        />
      </CardItemWrapper>
    </WithdrawCardWrapper>
  );
}

export default WithdrawCard;
